import { render } from "./PaymentSuccess.vue?vue&type=template&id=03bb0c78"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"

import "./PaymentSuccess.vue?vue&type=style&index=0&id=03bb0c78&lang=css"

import exportComponent from "/Users/a2019/Documents/Project/MiniApp/miniapp_wing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__